import { Resolver } from 'craft/types';

import { Link } from './src/Link';
import { List } from './src/List';
import { ListItem } from './src/ListItem';
import { Typography } from './src/Typography';
import { Variable } from './src/Variable';

export const resolvers: Record<string, Resolver> = {
  Link,
  List,
  ListItem,
  Typography,
  Variable,
};
